import { useEffect, useRef } from 'react'
import { ChevronUp } from 'react-feather'
import { setScrollElement } from '@/redux/actions/scrollAction'
import { useDispatch } from 'react-redux'
import { performScroll } from '@/functions/ui/scroller'

const Scroller = () => {
    const inputEl = useRef(null)

    useEffect(() => {
        let current = inputEl.current

        if (typeof window !== 'undefined') {
            window.onscroll = () => {
                let currentScrollPos = window.pageYOffset
                //let maxScroll = document.body.scrollHeight - window.innerHeight
                if (currentScrollPos > 300) {
                    current.classList.remove('scroller-hidden')
                    current.classList.add('scroller-visible')
                } else {
                    current.classList.add('scroller-hidden')
                    current.classList.remove('scroller-visible')
                }
            }
        }
    })

    const dispatch = useDispatch()

    const scrollToTop = () => {
        performScroll(0)
        dispatch(setScrollElement('catTopPage'))
    }
    return (
        <div
            ref={inputEl}
            className={`scroller-hidden shadow-buttons fixed z-50  p-4 bottom-24 mr-4 right-0  bg-turbo-background rounded-full hover:cursor-pointer hover:brightness-95 active:brightness-90`}
            onClick={scrollToTop}
        >
            <ChevronUp size={32} color={'#E30A18'} />
        </div>
    )
}

export default Scroller
